import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { APPLICATION_URL } from '../constants/assets';

const { FiFileText, FiUsers, FiShield, FiCheckCircle, FiArrowRight } = FiIcons;

const ApplicationProcess = () => {
  const steps = [
    {
      icon: FiFileText,
      title: "Apply Online",
      desc: "Complete our simple 5-minute digital application."
    },
    {
      icon: FiUsers,
      title: "Interview",
      desc: "We'll schedule a time to discuss your skills and goals."
    },
    {
      icon: FiShield,
      title: "Background Check",
      desc: "Standard safety and background screening process."
    },
    {
      icon: FiCheckCircle,
      title: "Start Date",
      desc: "Join the MAG team and begin your professional training."
    }
  ];

  return (
    <section className="py-24 bg-mag-black text-white px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black mb-4 uppercase tracking-tighter">
            How to <span className="text-mag-green">Join the Team</span>
          </h2>
          <p className="text-xl text-gray-400 font-bold">A straightforward process to start your new career.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, idx) => (
            <div key={idx} className="relative group p-8 bg-white/5 rounded-[2rem] border border-white/10 hover:border-mag-green transition-all">
              <div className="w-20 h-20 bg-mag-blue rounded-2xl flex items-center justify-center mb-6 border-b-4 border-mag-green shadow-xl">
                <SafeIcon icon={step.icon} className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-black mb-3 uppercase tracking-tight">{step.title}</h3>
              <p className="text-gray-400 text-sm font-bold leading-relaxed">{step.desc}</p>
              
              {idx < 3 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <SafeIcon icon={FiArrowRight} className="w-8 h-8 text-mag-green" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <a 
            href={APPLICATION_URL} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block bg-mag-green text-white px-12 py-6 rounded-2xl font-black text-2xl hover:brightness-110 shadow-[0_20px_50px_rgba(110,188,41,0.3)] uppercase tracking-widest w-full sm:w-auto"
          >
            Start Application
          </a>
        </div>
      </div>
    </section>
  );
};

export default ApplicationProcess;